import React from "react";
import useTableData from "./useTableData";
import ListViewCommon from "./ListViewCommon";

const headers = [
    {"label": "Nazov", 'caption': "Názov", 'filter': 'string'},
]

function Products(props) {
    const initialFilters = [
        {
            'label': 'Nazov',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Nazov',
        }
    ]

    const baseUrl = '/product/product_groups'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Nazov': `/product_groups/product_group/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={`/product_groups/product_group`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Produktové skupiny"}
        />
    )
}

export default Products
